require('./page-not-found/page-not-found.scss');
var BaseViews = require('./base');
var PageNotFoundView = BaseViews.LayoutView.extend({
    className: 'fmcy-page-not-found',
    template: require('./page-not-found/page-not-found.html'),
});
module.exports = PageNotFoundView;



/** WEBPACK FOOTER **
 ** ./assets/js/common/page-not-found.js
 **/